module.exports = __webpack_public_path__ + "img/industri_paavirkning_gruver_sanduttak.bdf1c9e5.jpg";